import React from 'react';
import { QRCodeSVG } from 'qrcode.react';

function QrGenerator({ info }) {
    if (typeof Number(info) === 'number' && !isNaN(Number(info)) && Number(info) !== 0) {
        try {
            return (
                <div className='flex justify-center'>
                    <QRCodeSVG value={info} size={45} level='M' />
                </div>
            );
        } catch (err) {
            console.error('Kunne ikke generere QR-kode', err);
            return <div className='font-bold'>PLU</div>;
        }
    }

    return <div className='font-bold'>{info}</div>;
}

export default QrGenerator;
